import { EExceptionDomain } from '../../../types/exceptionDomains';

export function getDomainBySource(source: string) {
  return `${EExceptionDomain.FirstMessageSend}.${source}`;
}
